const SORT_BY_LABELS: Record<string, string> = {
  postedAt: 'Posted At',
  likes: 'Likes',
  downloads: 'Downloads',
};

const SORT_ORDER_LABELS: Record<string, Record<string, string>> = {
  postedAt: {
    '-1': 'Newest First',
    '1': 'Oldest First',
  },
  likes: {
    '-1': 'Most Liked',
    '1': 'Least Liked',
  },
  downloads: {
    '-1': 'Most Downloaded',
    '1': 'Least Downloaded',
  },
};

const DEFAULT_ORDER = '-1';

function orderLabel(sortBy: string, sortOrder: string): string {
  const labels = SORT_ORDER_LABELS[sortBy] ?? {};
  return labels[sortOrder] ?? sortOrder;
}

/** The chip text for the active sort, or null when nothing is sorted. */
export default function sortLabel(
  sortBy: string | null | undefined,
  sortOrder: string | null | undefined
): string | null {
  if (!sortBy) return null;
  const order = sortOrder ?? DEFAULT_ORDER;
  return `Sorted By: ${SORT_BY_LABELS[sortBy] ?? sortBy} - ${orderLabel(sortBy, order)}`;
}
